import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';

export default class StartpageElementViewModel extends ControlViewModel {

    /**
     * Das ViewModel für das Icon
     */
    public image: ImageViewModel;

    /**
     * Das ViewModel für die Überschrift
     */
    public label: LabelViewModel;

    /**
     * Die ViewModels für die Links
     */
    public items: KnockoutObservable<Array<LinkViewModel>>;

    public customElement?: string;
    public customViewModel?: ControlViewModel;

    /**
     * Repräsentiert ein Element der Startseite
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.image = this.paramOrDefault(params.image, null);
        this.label = this.paramOrDefault(params.label, null);
        this.items = this.observableOrDefault(params.items, []);
        this.customElement = this.paramOrDefault(params.customElement, undefined);
        this.customViewModel = this.paramOrDefault(params.customViewModel, undefined);
    }
}

ComponentManager.setViewModel('StartpageElementViewModel', StartpageElementViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');